var KeyValueScope = (function () {
    function KeyValueScope() {
    }
    KeyValueScope.NONE = -1;
    KeyValueScope.FROM_HEADER = -2;
    return KeyValueScope;
}());
export { KeyValueScope };
//# sourceMappingURL=KeyValueScope.js.map